<template>
  <div class="mainNew">
    <div class="topTitle">
      <span style="font-family:'PingFangBold';color:#333333;font-size: 16px;"
        >教务中心</span
      >
      / 课表
    </div>

    <div class="listen-test-management">
      <div>
        <FullCalendar ref="fullCalendar" :options="calendarOptions">
          <template v-slot:eventContent="arg">
            <el-popover
              placement="right"
              title=""
              width="300"
              :visible-arrow="true"
              trigger="hover"
              style="z-index: 9999;"
            >
              <div style="overflow: auto;">
                <div class="fl">
                  <div class="title">{{ arg.event.title }}</div>
                </div>
                <!-- <div class="fr" @click="clear(arg.event.extendedProps)">
                                    <i class="el-icon-delete"></i>
                                </div>
                                <div class="fr" @click="GoSign(arg.event.extendedProps)" style="margin-right: 10px;">
                                    <i class="el-icon-setting"></i>
                                </div>

                                <div class="fr" @click="AddStudentToPlan(arg.event.extendedProps)"
                                    style="margin-right: 10px;">
                                    <i class="el-icon-circle-plus-outline"></i>
                                </div> -->
              </div>

              <div style="margin-top: 15px;">
                {{ arg.event.extendedProps.class_date }}
                {{ arg.event.extendedProps.week }}
                {{ arg.event.extendedProps.start_class_date.split(' ')[1] }} ~
                {{ arg.event.extendedProps.end_class_date.split(' ')[1] }}
              </div>
              <div style="margin-top: 15px;">
                授课班级：{{ arg.event.title }}
              </div>
              <div style="margin-top: 15px;">
                授课课程：{{ arg.event.extendedProps.lessionInfo.title }}
              </div>
              <div style="margin-top: 15px;">
                上课老师：{{ arg.event.extendedProps.lecturerName }}
              </div>
              <div style="margin-top: 15px;">
                人数/容量：{{ arg.event.extendedProps.stuSignNum }} /
                {{ arg.event.extendedProps.stuTotalSignNum }}
                <span
                  style="cursor: pointer; margin-left: 10px; color: #0068FF;"
                  @click="num(arg.event.extendedProps)"
                  >查看</span
                >
              </div>
              <div slot="reference">
                <div style="overflow: hidden; width: 100%;">
                  <div style="overflow: hidden;">
                    <div
                      class="fl"
                      v-if="isShowBorder"
                      style="width: 6px; height: 6px;border-radius: 50%;margin-top: 7px;margin-right: 5px; margin-left: 5px;"
                      :style="{ backgroundColor: arg.event.backgroundColor }"
                    ></div>
                    <div
                      class="fl"
                      :style="{
                        lineHeight: isShowBorder === true ? '20px' : '',
                      }"
                    >
                      <div>
                        {{
                          arg.event.extendedProps.start_class_date.split(' ')[1]
                        }}
                        ~
                        {{
                          arg.event.extendedProps.end_class_date.split(' ')[1]
                        }}
                      </div>
                      <div>{{ arg.event.title }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-popover>
          </template>
        </FullCalendar>
      </div>
    </div>
    <!--修改讲次信息-->
    <el-dialog
      width="660px"
      top="10vh"
      title="编辑讲次信息"
      :visible.sync="dialogFormVisible7"
      z-index="9999"
    >
      <el-form
        size="mini"
        :model="updateform"
        ref="form"
        label-width="100px"
        label-position="center"
      >
        <el-form-item label="排序号">
          <el-input-number
            v-model="updateform.sort_num"
            :precision="2"
            :step="0.01"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="讲次名称" required>
          <el-input
            disabled
            v-model="updateform.title"
            placeholder="请输入讲次"
            style="width: 500px"
          ></el-input>
        </el-form-item>

        <el-form-item label="上课老师" required>
          <el-select
            v-model="updateform.lecturer_id"
            style="width: 500px"
            :disabled="updateform.start_date"
          >
            <el-option
              :label="item.realName + ' ' + '(' + item.name + ')'"
              :value="item.id"
              v-for="(item, index) of teacherList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上课日期" required>
          <el-date-picker
            type="date"
            placeholder="请选择课程开始时间"
            v-model="updateform.class_date"
            style="width: 500px"
            value-format="yyyy-MM-dd"
            placement="bottom-start"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="上课时段" required>
          <el-time-picker
            v-model="updateform.start_time"
            placeholder="选择开始时间"
            value-format="HH:mm:ss"
          >
          </el-time-picker
          >至
          <el-time-picker
            v-model="updateform.end_time"
            placeholder="选择结束时间"
            value-format="HH:mm:ss"
          ></el-time-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible7 = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="updateTeachingPlan"
          >修 改</el-button
        >
      </div>
    </el-dialog>
    <!-- 签到信息 -->
    <el-dialog
      title="签到信息"
      :visible.sync="dialogVisible5"
      width="80%"
      top="5vh"
    >
      <el-table
        :data="stuPlanList1"
        style="width: 100%"
        height="60vh"
        :header-cell-style="{ background: '#f5f7fa' }"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column width="50" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + (page_no10 - 1) * page_size10 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <span>{{ scope.row.studentInfo.studentUserInfo.realname }}</span>
          </template>
        </el-table-column>
        <el-table-column label="性别">
          <template slot-scope="scope">
            <span>{{ scope.row.studentInfo.studentUserInfo.sex }}</span>
          </template>
        </el-table-column>
        <el-table-column label="账号">
          <template slot-scope="scope">
            <span>{{ scope.row.studentInfo.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="出勤状态">
          <template slot-scope="scope">
            <span v-if="scope.row.stu_tch_plan_type === 1">
              <span v-if="scope.row.sign_state == 1">
                已出勤
              </span>
              <span v-else-if="scope.row.sign_state == 2">
                缺勤
              </span>
            </span>
            <span v-if="scope.row.stu_tch_plan_type === 4">
              <span v-if="scope.row.sign_state == 1">
                已补课
              </span>
              <span v-else-if="scope.row.sign_state == 2">
                缺勤
              </span>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-style">
        <el-pagination
          @size-change="handleSizeChange10"
          @current-change="handleCurrentChange10"
          :current-page="page_no10"
          :page-sizes="[10, 15, 20, 30, 40, 50, 100]"
          :page-size="page_size10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total10"
        ></el-pagination>
      </div>
    </el-dialog>
    <!--点名上课-->
    <el-dialog width="80%" title="点名上课" :visible.sync="dialogFormVisible2">
      <el-row>
        <el-col :span="8">
          <div>
            <span>班级名称:</span>
            <span style="margin-left: 20px">
              {{ SignClassInfo.classInfo.name }}
            </span>
          </div>
        </el-col>
        <el-col :span="8">
          <div v-if="isShow">
            <span>上课时间:</span>
            <span style="margin-left: 20px">
              {{ SignClassInfo.start_class_date }} -
              {{ SignClassInfo.end_class_date.slice(10, 20) }}
            </span>
          </div>
        </el-col>

        <el-col :span="8">
          <div>
            <el-checkbox
              v-model="allcost"
              style="float: right; margin-right: 0px"
              @click.native="SetAllCost($event)"
            >
              批量计费</el-checkbox
            >

            <el-checkbox
              v-model="allsign"
              style="float: right; margin-right: 20px"
              @click.native="SetAllSign($event)"
              >批量全勤</el-checkbox
            >
          </div>
        </el-col>
      </el-row>

      <div style="margin-top: 20px">
        <el-table
          ref="multipleTable"
          size="small"
          :data="SignStudents"
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa' }"
          @selection-change="handleSelectionChange1"
        >
          >
          <el-table-column type="selection" width="55"></el-table-column>

          <el-table-column align="center" label="姓名" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.stu_tch_plan_type == '1'">
                {{ scope.row.studentInfo.studentUserInfo.realname }}
              </span>
              <span v-else-if="scope.row.stu_tch_plan_type == '2'">
                {{ scope.row.studentInfo.studentUserInfo.realname }}
                <span style="color: #e6a23c">(试听)</span>
              </span>
              <span v-else-if="scope.row.stu_tch_plan_type == '3'">
                {{ scope.row.studentInfo.studentUserInfo.realname }}
                <span style="color: #e6a23c">(调课)</span>
              </span>
              <span v-else-if="scope.row.stu_tch_plan_type == '4'">
                {{ scope.row.studentInfo.studentUserInfo.realname }}
                <span style="color: #e6a23c">(补课)</span>
              </span>
              <span v-else-if="scope.row.stu_tch_plan_type == '5'">
                {{ scope.row.studentInfo.studentUserInfo.realname }}
                <span style="color: #e6a23c">(临加)</span>
              </span>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            prop="studentInfo.name"
            label="平台账号"
            width="150"
          ></el-table-column>

          <el-table-column align="center" label="出勤状态" width="110">
            <template slot-scope="scope">
              <el-select
                size="mini"
                v-model="scope.row.sign_state"
                placeholder="请选择出勤状态"
                clearable
              >
                <el-option label="出勤" :value="1"></el-option>
                <el-option label="缺勤" :value="2"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column align="center" label="计费状态" width="110">
            <template slot-scope="scope">
              <el-select
                size="mini"
                v-model="scope.row.cost_state"
                placeholder="请选择计费状态"
                clearable
              >
                <el-option label="计费" :value="1"></el-option>
                <el-option label="不计费" :value="2"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column align="center" label="缺勤原因" width="110">
            <template slot-scope="scope">
              <el-select
                size="mini"
                v-model="scope.row.not_come_reason"
                placeholder="请选择"
                clearable
              >
                <el-option label="事假" :value="1"></el-option>
                <el-option label="病假" :value="2"></el-option>
                <el-option label="旷课" :value="3"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column align="center" label="备注" width="150">
            <template slot-scope="scope">
              <el-input
                clearable
                size="mini"
                type="text"
                v-model="scope.row.remark"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column align="center" label="微信通知" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.is_send_wx_message">已发送</span>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            align="center"
            label="通知时间"
            prop="send_wx_message_date"
          ></el-table-column>

          <el-table-column
            width="150"
            align="center"
            label="签到时间"
            prop="sign_date"
            fixed="right"
          ></el-table-column>

          <el-table-column
            align="center"
            label="操作"
            width="100"
            fixed="right"
          >
            <template slot-scope="scope">
              <i
                @click="deleteStuOfTeachingPlan(scope.row.student_user_id)"
                style="cursor: pointer"
                class="el-icon-delete"
              ></i>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer">
        <!-- <el-tooltip class="item" effect="dark" content="为缺勤的学员,单独生成一条补课计划。推荐补课场景使用此操作，方便准确的统计业绩。" placement="top" v-if="
            !SignClassInfo.supplement_original_tch_plan_id &&
            SignClassInfo.classInfo.curriculum_class_type == 1
          ">
            <el-button style="float: left" size="small" @click="openSupplementTchPlan">补课<i class="el-icon-question el-icon--right"></i></el-button>
          </el-tooltip>-->

        <el-button size="small" @click="dialogFormVisible2 = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="updateSign"
          :disabled="SignClassInfo.teachingPlanState == '未开课'"
          >提交签到信息</el-button
        >
      </div>
      <div class="pagination-style">
        <el-pagination
          @size-change="handleSizeChange11"
          @current-change="handleCurrentChange11"
          :current-page="page_no11"
          :page-sizes="[10, 15, 20, 30, 40, 50, 100]"
          :page-size="page_size11"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total11"
        ></el-pagination>
      </div>
    </el-dialog>
    <!--添加学员-->
    <el-dialog
      title="选择学员"
      :visible.sync="dialogVisible1"
      width="80%"
      top="10vh"
    >
      <el-form :inline="true" size="mini" @submit.native.prevent>
        <el-form-item label>
          <el-input
            style="width: 250px"
            v-model="form1.realname"
            placeholder="请输入学员姓名"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search_student">查询</el-button>
        </el-form-item>
      </el-form>

      <div>
        <el-table
          size="mini"
          :data="Student_tableData"
          @selection-change="CurrentChange_Student"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column type="selection" width="55"></el-table-column>

          <el-table-column fixed="left" width="150" align="center" label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.studentUserInfo.realname }}</span>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            align="center"
            prop="name"
            label="账号"
          ></el-table-column>

          <el-table-column width="50" align="center" prop="sex" label="性别">
            <template slot-scope="scope">
              <span>{{ scope.row.studentUserInfo.sex }}</span>
            </template>
          </el-table-column>

          <el-table-column width="150" align="center" label="学校名称">
            <template slot-scope="scope">
              <span>{{ scope.row.studentUserInfo.school_name }}</span>
            </template>
          </el-table-column>
          <el-table-column width="150" align="center" label="在校年级">
            <template slot-scope="scope">
              <span>{{ scope.row.studentUserInfo.gradeStr }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="所在班级" width="200">
            <template slot-scope="scope">
              <div
                v-for="item in scope.row.curriculum_class_list"
                :key="item.id"
              >
                <span>{{ item.name }}</span>
                <br />
              </div>
            </template>
          </el-table-column>

          <el-table-column width="150" align="center" label="联系电话">
            <template slot-scope="scope">
              <span>{{ scope.row.studentUserInfo.parent_a }}</span>
              <span>{{ scope.row.studentUserInfo.parent_a_phone_num }}</span>
            </template>
          </el-table-column>

          <el-table-column width="150" align="center" label="家长微信">
            <template slot-scope="scope">
              <span>{{ scope.row.studentUserInfo.parent_b }}</span>
              <span>{{ scope.row.studentUserInfo.parent_b_phone_num }}</span>
            </template>
          </el-table-column>

          <el-table-column width="150" align="center" label="负责人">
            <template slot-scope="scope">
              <span>{{ scope.row.studentUserInfo.leaderName }}</span>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            align="center"
            prop="normal_state"
            label="学员状态"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.normal_state == '1'">试听</span>
              <span v-else-if="scope.row.normal_state == '2'">在读</span>
              <span v-else-if="scope.row.normal_state == '3'">休学</span>
              <span v-else-if="scope.row.normal_state == '4'">已退学</span>
              <span v-else>未知</span>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            align="center"
            prop="created_time"
            label="录入时间"
          ></el-table-column>
        </el-table>
      </div>
      <div class="pagination-style">
        <el-pagination
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="page_no2"
          :page-sizes="[10, 15, 20, 30, 40, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total2"
        ></el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible1 = false">取消</el-button>
        <el-button size="small" type="primary" @click="addStuToTeachingPlan"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import zhCNLocale from '@fullcalendar/core/locales/zh-cn';
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'

import moment from 'moment'
import {
  getTeachingPlanList,
  //   getCampusTeacherList,
  updateTeachingPlan,
  getTeachingPlanStuList,
  clearTchPlan,
  deleteStuOfTeachingPlan,
  updateTchPlanSignState,
  updateStuTeachingPlanSignInfo,
  getFormalStudentListForAddToTchPlan,
  addStuToTeachingPlan,
} from '@/api/educational.js'
import { api_eduCampusSelectTchListByCampus } from '@/api/javaApi'

export default {
  name: 'teachplan',
  components: {
    // 注册
    FullCalendar,
  },
  data() {
    return {
      chooseStudent_current: [], //选择的学员
      //选择学员
      page_no2: 1,
      page_size2: 10,
      total2: 0,
      teachplan_form: {
        title: '', //讲次名称
        educational_institution_campus_id: '',
        classname: '', //班级名称
        week: [], //星期
        time: [], //时段 上下午 晚上
        sign_state: '', //开课状态
        default_time: '', //默认时间
        date: [],
        lecturer_id: '', // 上课老师
      },
      Student_tableData: [],
      form1: {},
      dialogVisible1: false,
      current_teachplan_id: '', //当前教学计划ID
      //签到学员列表
      signStus: [],
      allcost: false,
      allsign: false,
      isShow: true,
      SignStudents: [], //签到学员信息
      page_no11: 1,
      page_size11: 20,
      total11: 0,
      //签到班级信息
      SignClassInfo: {
        classInfo: { name: '' },
        start_class_date: '',
        end_class_date: '',
      },
      dialogFormVisible2: false,
      teachingPlanId: '',
      stuPlanList1: [],
      page_no10: 1,
      page_size10: 20,
      total10: 0,
      dialogVisible5: false,
      teacherList: [], //所属校区的教师列表
      updateform: {
        title: '',
        lecturer_id: '',
        educational_institution_campus_id: '',
        class_date: '',
        value: [],
        teaching_plan_id: '',
        start_time: '',
        end_time: '',
        sort_num: '00.00',
      },
      dialogFormVisible7: false,
      startTime: '',
      entTime: '',
      courseList: [],
      isShowBorder: true,
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin],
        initialDate: new Date(),
        initialView: 'dayGridMonth', // 日历加载时的初始视图，默认值为'dayGridMonth'，可以为任何可用视图的值，如例如'dayGridWeek'，'timeGridDay'，'listWeek'
        locale: 'zh',
        firstDay: 1, //new Date().getDay(), // 设置一周中显示的第一天是哪天，周日是0，周一是1，类推  new Date().getDay()当前天
        selectable: true, // 是否可以选中日历格
        selectOverlap: false, // 是否允许重叠
        slotEventOverlap: false, // 相同时间段的多个日程视觉上是否允许重叠，默认true允许
        eventOverlap: false, // 拖拽时是否重叠
        nowIndicator: true, // 当前的时间线显示,为true时当前小时那一格有个红线，并且有红三角
        aspectRatio: '2.0', // 设置日历的宽高比率
        buttonText: {
          // 文本将显示在headerToolbar / footerToolbar的按钮上。不支持HTML注入。所有特殊字符将被转义。
          today: '今天',
          month: '月',
          week: '周',
          day: '天',
          list: '周列表',
        },
        headerToolbar: {
          // 在日历顶部定义按钮和标题。将headerToolbar选项设置为false不会显示任何标题工具栏。可以为对象提供属性start/center/end或left/center/right。这些属性包含带有逗号/空格分隔值的字符串。用逗号分隔的值将相邻显示。用空格分隔的值之间会显示一个很小的间隙。
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay listWeek',
        },
        eventTimeFormat: {
          hour: 'numeric',
          minute: '2-digit',
          hour12: false,
        },
        views: {
          // dayGridMonth: {
          //     titleFormat: { year: 'numeric', month: 'long', day: 'numeric', weekday: 'short' },
          //     dayHeaderContent: this.addTextToHeader
          // },
          timeGridWeek: {
            titleFormat: {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              weekday: 'short',
            },
            dayHeaderContent: this.addTextToHeader,
          },
          timeGridDay: {
            titleFormat: {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              weekday: 'short',
            },
            dayHeaderContent: this.addTextToHeader,
          },
          listWeek: {
            titleFormat: {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              weekday: 'short',
            },
            dayHeaderContent: this.addTextToHeader,
          },
        },

        // 是否显示全天插槽
        allDaySlot: false, //是否显示日历上方的allDay
        // eventContent(info) {
        //     info.event._contex.dateEnv.weekDoy = '5'
        //     // if (info.event.allDay) { }
        // },

        // // 时间轴间距
        // slotMinTime: '00:00',
        // slotMaxTime: '23:00',
        // slotDuration: '00:15:00',
        // defaultTimedEventDuration: '00:30',
        // // 月视图，是否为指定周数高度，true 6周高度
        fixedWeekCount: false,
        // // 月视图，是否显示非本月日期
        showNonCurrentDates: false,

        weekends: true,
        dayMaxEvents: true,
        slotLabelFormat: {
          hour: 'numeric',
          minute: '2-digit',
          hour12: false,
        },
        events: [],
        titleFormat: this.getTitle, // 使用自定义标题格式
        dayCellContent: this.renderTasks,
        dateClick: this.handleEvent, // 点击日期
        eventClick: this.cancelClick, // 点击事件时，触发该回调
        datesSet: this.datesSet, //日期渲染；修改日期范围后触发 点击头部按钮
        // eventMouseEnter: this.eventMouseEnter
      },
      teachingPlan: [], //教学计划列表
      color: '',
    }
  },
  computed: {},
  mounted() {
    // this.info()
    this.getCampusTeacherList()
  },
  methods: {
    handleChange(event) {
      const date = event.target.value
      this.$refs.calendar.getApi().gotoDate(date) // 跳转到指定日期
    },
    addTextToHeader(arg) {
      console.log(arg.date, 463623)
      console.log(arg.date.toString().slice(0, 10), 463623)
      let tasks = this.teachingPlan.filter(
        (task) => task.class_date === moment(arg.date).format('YYYY-MM-DD')
      )
      return arg.text + '(' + tasks.length + '节课）'
    },
    CurrentChange_Student(val) {
      console.log('选择了学员')
      console.log(val)
      this.chooseStudent_current = []

      for (let k = 0; k < val.length; k++) {
        this.chooseStudent_current.push(val[k].id)
      }
    },
    //向教学计划中添加学员
    addStuToTeachingPlan() {
      console.log('添加学员参数')
      console.log(this.current_teachplan_id)
      console.log(this.chooseStudent_current)

      addStuToTeachingPlan({
        teaching_plan_id: this.current_teachplan_id,
        studentIds: JSON.stringify(this.chooseStudent_current),
        stu_tch_plan_type: '2', //临调学员
      }).then((res) => {
        console.log('向教学计划中添加学员')
        console.log(res)
        if (res.is_update) {
          this.$message.success('添加学员成功')
          this.dialogVisible1 = false
          this.getTeachingPlanList1()
          this.oldTeachingPlanList()
        }
      })
    },

    search_student() {
      this.getFormalStudentListForAddToTchPlan()
    },

    handleSizeChange2(val) {
      this.page_size2 = val
      //this.getTeachingPlanList1();
      this.getFormalStudentListForAddToTchPlan()
    },
    handleCurrentChange2(val) {
      this.page_no2 = val
      this.getFormalStudentListForAddToTchPlan()

      //this.getTeachingPlanList1();
    },
    AddStudentToPlan(row) {
      console.log('添加学员')
      console.log(row)
      this.current_teachplan_id = row.id
      this.dialogVisible1 = true
      this.teachplan_form.educational_institution_campus_id =
        row.educational_institution_campus_id
      //TODO 查询所有学员
      this.getFormalStudentListForAddToTchPlan()
    },
    //查询所有正式学员
    getFormalStudentListForAddToTchPlan() {
      console.log('添加学员，所属校区')
      console.log(this.teachplan_form.educational_institution_campus_id)

      getFormalStudentListForAddToTchPlan({
        realname: this.form1.realname,
        leader: this.form1.leader,
        teaching_plan_id: this.current_teachplan_id,
        phone_a_num: this.form1.phone_a_num,
        normal_state: this.form1.normal_state,
        educational_institution_campus_id: this.teachplan_form
          .educational_institution_campus_id,
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log('查询所有正式学员')
        console.log(res)
        this.Student_tableData = res.studentList
        this.total2 = res.total
      })
    },
    //更新学员签到信息
    updateStuTeachingPlanSignInfo() {
      updateStuTeachingPlanSignInfo({
        stuSignInfoList: JSON.stringify(this.stuSignInfoList),
        teaching_plan_id: this.current_teachplan_id,
      }).then((res) => {
        console.log('更新学员签到信息')
        console.log(res)
        if (res.is_update) {
          this.$message.success('签到成功')
          this.SignStudents = []
          this.getTeachingPlanStuList(this.current_teachplan_id)
          this.dialogFormVisible2 = false
          this.getTeachingPlanList1()
        }
      })
    },
    //更新教学计划的签到状态
    updateTchPlanSignState(id) {
      console.log('更新上课状态')
      console.log(id)

      updateTchPlanSignState({
        teaching_plan_id: id,
      }).then((res) => {
        console.log('更新教学计划的签到状态')
        console.log(res)
      })
    },
    //更新教学计划签到信息
    updateSign() {
      console.log('签到学员信息')
      console.log(this.signStus)
      console.log('上课状态')
      console.log(this.SignClassInfo)

      if (this.SignClassInfo.sign_state == '2') {
        this.updateTchPlanSignState(this.current_teachplan_id)
      }

      if (this.signStus.length == 0) {
        this.$message.warning('选勾选签到学员')
        return
      }

      for (let k = 0; k < this.signStus.length; k++) {
        if (!this.signStus[k].sign_state) {
          this.$message.warning(
            this.signStus[k].studentInfo.studentUserInfo.realname +
              ',出勤状态不能为空'
          )
          this.toggleSelection(this.signStus.slice(k))
          return
        }

        if (!this.signStus[k].cost_state) {
          this.$message.warning(
            this.signStus[k].studentInfo.studentUserInfo.realname +
              ',计费状态不能为空'
          )
          this.toggleSelection(this.signStus.slice(k))
          return
        }
      }

      this.stuSignInfoList = []

      for (let k = 0; k < this.signStus.length; k++) {
        const sign_stu = {
          stuId: this.signStus[k].student_user_id,
          cost_state: this.signStus[k].cost_state,
          sign_state: this.signStus[k].sign_state,
          not_come_reason: this.signStus[k].not_come_reason,
          remark: this.signStus[k].remark,
        }
        this.stuSignInfoList.push(sign_stu)
      }

      console.log('转化后的学员信息')
      console.log(this.stuSignInfoList)
      this.updateStuTeachingPlanSignInfo()
    },
    //从教学计划中移除学员
    deleteStuOfTeachingPlan(id) {
      this.$confirm('确定将该学员从本讲次移除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteStuOfTeachingPlan({
          teaching_plan_id: this.current_teachplan_id,
          studentId: id,
        }).then((res) => {
          console.log('将学员移除讲次')
          console.log(res)
          if (res.is_delete) {
            this.$message.success('移除学员成功')
            this.getTeachingPlanStuList(this.current_teachplan_id)
          }
        })
      })
    },

    //更新学员签到信息
    handleSelectionChange1(val) {
      console.log('签到学员列表')
      console.log(val)
      this.signStus = val
    },
    //全部标记为出勤
    SetAllSign(e) {
      if (e.target.tagName === 'INPUT') return // 因为原生click事件会执行两次，第一次在label标签上，第二次在input标签上，故此处理

      console.log('全部标记为出勤')
      console.log(this.allsign)
      console.log(this.stuSignInfoList)

      if (!this.allsign) {
        console.log('批量全勤')
        if (this.signStus.length == 0) {
          this.$message.warning('请选择学员')
          return
        } else {
          for (let j = 0; j < this.SignStudents.length; j++) {
            for (let k = 0; k < this.signStus.length; k++) {
              if (this.SignStudents[j].id == this.signStus[k].id) {
                this.SignStudents[j].sign_state = 1
              }
            }
          }
        }
      } else {
        console.log('批量取消全勤')
        if (this.signStus.length == 0) {
          this.$message.warning('请选择学员')
          return
        } else {
          for (let j = 0; j < this.SignStudents.length; j++) {
            for (let k = 0; k < this.signStus.length; k++) {
              if (this.SignStudents[j].id == this.signStus[k].id) {
                this.SignStudents[j].sign_state = null
              }
            }
          }
        }
      }
    },
    //全部标记为计费
    SetAllCost(e) {
      if (e.target.tagName === 'INPUT') return // 因为原生click事件会执行两次，第一次在label标签上，第二次在input标签上，故此处理

      console.log('全部标记为计费')
      console.log(e)
      console.log(this.allcost)
      console.log(this.stuSignInfoList)

      if (!this.allcost) {
        console.log('批量计费')
        if (this.signStus.length == 0) {
          this.$message.warning('请选择学员')
          return
        } else {
          for (let j = 0; j < this.SignStudents.length; j++) {
            for (let k = 0; k < this.signStus.length; k++) {
              if (this.SignStudents[j].id == this.signStus[k].id) {
                this.SignStudents[j].cost_state = 1
              }
            }
          }
        }
      } else {
        console.log('批量取消计费')
        if (this.signStus.length == 0) {
          this.$message.warning('请选择学员')
          return
        } else {
          for (let j = 0; j < this.SignStudents.length; j++) {
            for (let k = 0; k < this.signStus.length; k++) {
              if (this.SignStudents[j].id == this.signStus[k].id) {
                this.SignStudents[j].cost_state = null
              }
            }
          }
        }
      }
    },
    //点名
    GoSign(row) {
      this.teachingPlanId = row.id
      if (row.start_class_date === null && row.end_class_date == null) {
        this.isShow = false
      } else {
        this.isShow = true
      }

      if (row.start_class_date === null && row.end_class_date === null) {
        row.sign_date = ''
        row.start_class_date = ''
        row.end_class_date = ''
        console.log(row.start_class_date)
        console.log(row.end_class_date)
        this.allsign = false
        this.allcost = false

        this.SignStudents = []
        this.dialogFormVisible2 = true
        this.SignClassInfo = row
        this.current_teachplan_id = row.id
        console.log(row)
        this.getTeachingPlanStuList(row.id)
      } else {
        this.allsign = false
        this.allcost = false

        this.SignStudents = []
        this.dialogFormVisible2 = true
        this.SignClassInfo = row
        this.current_teachplan_id = row.id
        console.log(row)
        this.getTeachingPlanStuList(row.id)
      }
    },
    //获得教学计划对应的学生计划列表
    getTeachingPlanStuList(id) {
      getTeachingPlanStuList({
        teachingPlanId: id,
        page_no: this.page_no11,
        page_size: this.page_size11,
      }).then((res) => {
        console.log('获得教学计划对应的学生计划列表')
        console.log(res)
        this.SignStudents = res.stuPlanList
        this.total11 = res.total
      })
    },
    handleSizeChange11(val) {
      this.page_size11 = val
      this.getTeachingPlanStuList(this.teachingPlanId)
    },
    handleCurrentChange11(val) {
      this.page_no11 = val
      this.getTeachingPlanStuList(this.teachingPlanId)
    },
    //清空
    clear(row) {
      console.log(123)
      clearTchPlan({
        teaching_plan_id: row.id,
      }).then((res) => {
        this.$message.success('清空记录成功')
        console.log(res)
        this.getTeachingPlanList1()
      })
    },
    //查看签到信息
    num(row) {
      this.dialogVisible5 = true
      this.teachingPlanId = row.id

      console.log(row.id, 4564)
      getTeachingPlanStuList({
        teachingPlanId: row.id,
        page_no: this.page_no10,
        page_size: this.page_size10,
      }).then((res) => {
        console.log(res)
        this.stuPlanList1 = res.stuPlanList
        this.total10 = res.total
      })
    },
    handleSizeChange10(val) {
      this.page_size10 = val
      getTeachingPlanStuList({
        teachingPlanId: this.teachingPlanId,
        page_no: this.page_no10,
        page_size: this.page_size10,
      }).then((res) => {
        console.log(res)
        this.stuPlanList1 = res.stuPlanList
        this.total10 = res.total
      })
      //this.getTeachingPlanList1();
    },
    handleCurrentChange10(val) {
      this.page_no10 = val
      console.log(123)
      getTeachingPlanStuList({
        teachingPlanId: this.teachingPlanId,
        page_no: this.page_no10,
        page_size: this.page_size10,
      }).then((res) => {
        console.log(res)
        this.stuPlanList1 = res.stuPlanList
        this.total10 = res.total
      })
    },

    //未排课信息
    oldTeachingPlanList() {
      getTeachingPlanList({
        is_have_class_date: 0,
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        className: this.teachplan_form.classname, //班级名称
        curriculum_id: this.teachplan_form.curriculum_id, //课程体系ID

        sign_state_new: '',
        title: this.teachplan_form1.title,
        lecturer_id: this.teachplan_form1.lecturer_id,
        page_no: this.page_no3,
        page_size: this.page_size3,
      }).then((res) => {
        console.log('查询校区教学计划')
        console.log(res)
        this.TeachPlanList1 = res.teachingPlan
        this.total3 = res.total
      })
    },
    //编辑
    updateTeachingPlan() {
      console.log('更新讲次参数')
      console.log(this.updateform)
      if (!this.updateform.start_time) {
        this.$message.warning('请选择开始时间')
        return
      }
      if (!this.updateform.end_time) {
        this.$message.warning('请选择结束时间')
        return
      }
      updateTeachingPlan({
        lecturer_id: this.updateform.lecturer_id,
        teaching_plan_id: this.updateform.teaching_plan_id,
        class_date: this.updateform.class_date,
        start_class_date: this.updateform.start_time,
        end_class_date: this.updateform.end_time,
        title: this.updateform.title,
        classId: this.updateform.classId,
        if_ignore_conflict: this.if_ignore_conflict,
        sort_num: this.updateform.sort_num,
      }).then((res) => {
        console.log('更新课程讲次')
        console.log(res)
        if (res.is_update) {
          this.$message.success('修改成功')
          this.dialogFormVisible7 = false
          this.getTeachingPlanList1()
        } else {
          this.$confirm(res.msg, '提示', {
            confirmButtonText: '忽略冲突',
            cancelButtonText: '取消排课',
            type: 'warning',
          })
            .then(() => {
              this.if_ignore_conflict = '1'
              this.updateTeachingPlan()
              this.getTeachingPlanList1()
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '取消排课',
              })
              this.dialogFormVisible7 = false
            })
        }
      })
    },
    // 具有科目权限及课程体系的老师
    getCampusTeacherList() {
      api_eduCampusSelectTchListByCampus({
        eduCampusIdList: this.$store.state.user.selected_schools,
      }).then((res) => {
        console.log('具有科目权限及课程体系的老师')
        console.log(res)
        this.teacherList = res //主讲老师
      })
    },
    //编辑详情
    cancelClick(val) {
      this.dialogFormVisible2 = true
      this.GoSign(val.event._def.extendedProps)
      // 下面代码是编辑
      console.log(val, 4151212)
      // console.log(val.event._def.extendedProps, 4151212);
      // this.if_ignore_conflict = "0";
      // this.dialogFormVisible7 = true;
      // // this.teachplan_form.educational_institution_campus_id =
      // //     val.event._def.extendedProps.educational_institution_campus_id;
      // this.updateform.title = val.event._def.extendedProps.lessionInfo.title;
      // this.updateform.educational_institution_campus_id =
      //     val.event._def.extendedProps.educational_institution_campus_id;
      // this.updateform.lecturer_id = val.event._def.extendedProps.lecturer_id;
      // this.updateform.class_date = val.event._def.extendedProps.class_date;
      // this.updateform.classId = val.event._def.extendedProps.classInfo.id;
      // this.updateform.teaching_plan_id = val.event._def.extendedProps.id;
      // var time0 = val.event._def.extendedProps.start_class_date.split(" ")[1];
      // var time1 = val.event._def.extendedProps.end_class_date.split(" ")[1];
      // this.updateform.start_time = time0;
      // this.updateform.end_time = time1;
      // this.updateform.sort_num = val.event._def.extendedProps.sort_num
      // this.dialogFormVisible7 = true
    },
    // eventMouseEnter(val) {
    //     console.log(val, 5465656);
    //     console.log(122, 5465656);

    // },
    handleEvent(val) {
      console.log(val, 45121)
    },
    datesSet(val) {
      console.log(val, 5411212)

      if (val.view.type === 'dayGridMonth') {
        this.startTime = moment(val.startStr).format('YYYY-MM-DD 00:00:00')
        this.entTime = moment(val.endStr).format('YYYY-MM-DD 00:00:00')
        console.log(this.startTime, 4512122)
        console.log(this.entTime, 4512122)

        this.isShowBorder = true

        this.getTeachingPlanList1()
      } else if (val.view.type === 'timeGridWeek') {
        // this.startTime = moment().startOf('isoWeek').format("YYYY-MM-DD 00:00:00")
        // this.entTime = moment().endOf('isoWeek').format("YYYY-MM-DD 23:59:59")
        this.startTime = moment(val.startStr).format('YYYY-MM-DD 00:00:00')
        this.entTime = moment(val.endStr).format('YYYY-MM-DD 00:00:00')

        this.isShowBorder = false

        this.getTeachingPlanList1()
      } else if (val.view.type === 'timeGridDay') {
        this.startTime = moment(val.startStr).format('YYYY-MM-DD 00:00:00')
        this.entTime = moment(val.endStr).format('YYYY-MM-DD 00:00:00')

        this.isShowBorder = false

        this.getTeachingPlanList1()
      } else if (val.view.type === 'listWeek') {
        this.startTime = moment(val.startStr).format('YYYY-MM-DD 00:00:00')
        this.entTime = moment(val.endStr).format('YYYY-MM-DD 00:00:00')

        this.isShowBorder = true

        this.getTeachingPlanList1()
      }
      console.log(12221)
    },
    // info() {
    //     this.startTime = moment().startOf('month').format("YYYY-MM-DD 00:00:00")
    //     this.entTime = moment().endOf('month').format("YYYY-MM-DD 23:59:59")
    //     console.log(this.startTime, 4512122);
    //     // this.getTeachingPlanList1()
    // },
    // 获得排课教学计划
    getTeachingPlanList1() {
      getTeachingPlanList({
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        is_have_class_date: 1,
        start_date: this.startTime, //当前时间, // 开始时间
        end_date: this.entTime, // 结束时间
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        this.teachingPlan = res.teachingPlan
        this.$nextTick(() => {
          this.calendarOptions.events = []
          console.log(this.teachingPlan, 4623332)
          this.teachingPlan.map((item1) => {
            let time = moment(item1.class_date).valueOf()
            // console.log(moment(time).format('d'), 456465);
            let week = moment(time).format('d')
            if (week === '1') {
              item1.week = '星期一'
            } else if (week === '2') {
              item1.week = '星期二'
            } else if (week === '3') {
              item1.week = '星期三'
            } else if (week === '4') {
              item1.week = '星期四'
            } else if (week === '5') {
              item1.week = '星期五'
            } else if (week === '6') {
              item1.week = '星期六'
            } else if (week === '0') {
              item1.week = '星期日'
            }
            // console.log(item1, 46523);
            this.calendarOptions.events.push({
              backgroundColor:
                moment().isBetween(
                  item1.start_class_date,
                  item1.end_class_date,
                  null,
                  '()'
                ) == false
                  ? '#0068FF'
                  : '#0FCC3B',
              borderColor:
                moment().isBetween(
                  item1.start_class_date,
                  item1.end_class_date,
                  null,
                  '()'
                ) == false
                  ? '#0068FF'
                  : '#0FCC3B',
              title: item1.classInfo.name,
              start: item1.start_class_date,
              end: item1.end_class_date,
              extendedProps: item1,
              // allDay: true
            })
          })
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.fl {
  float: left;
}

.fr {
  float: right;
}

.mainNew {
  height: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.listen-test-management {
  min-height: calc(100% - 30px);
  background-color: #fff;
  margin: 10px;
  border-radius: 5px;
}

/deep/ .fc .fc-popover {
  z-index: 1;
}

/deep/ .fc .fc-list-event-dot {
  display: none;
}

/deep/ .fc-timegrid-event-harness > .fc-timegrid-event {
  overflow: hidden;
}

// /deep/ .fc .fc-daygrid-day.fc-day-today {
//     overflow: hidden;
// }
/deep/ .fc .fc-daygrid-day-frame {
  overflow: hidden;
}
</style>
